<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Download MIS Report</strong>       
          </div>       
          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row>           
              <b-col sm="3">
               <!--  <b-form-group label="Hub:"  :label-cols="4" >
                  <b-form-select v-model="hubid" name="hubid" class="mySelectBox" v-validate="'required|'" >
                    <option :value="selected">--Selected Hub--</option>
                    <option :value="hubs.pickuplocationmasterid" v-for="hubs in hubdata">
                      {{ hubs.pickuplocationname }}</option>
                  </b-form-select>                                
                </b-form-group>   -->   

                 <b-form-group label="Delivery Agent"  :label-cols="4" >
                 <b-form-select class="form-control input" v-model="deliveryagentid" name="deliveryagentid" >
                        <option :value="selected"  >--Select--</option>
                        <option v-for="agent in agentmaster"  v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}</option>
                   </b-form-select>
                  
                           
                </b-form-group>  

              </b-col>

             

              <b-col sm="3">
                <b-form-group label="Order Flow:"  :label-cols="4" >
                  <b-form-select v-model="orderflow" name="orderflow" class="mySelectBox" v-validate="'required'" >
                    <option :value="selected">--Selected order flow--</option>
                    <option value="both">All</option>
                    <option value="forward">Forward</option>
                    <option value="reverse">Reverse</option>
                  </b-form-select>                                
                </b-form-group>                   
              </b-col>
              
              <b-col sm="3">
                <b-form-group label="Status:"  :label-cols="4" >
                  <b-form-select v-model="shipmentstatus" name="shipmentstatus" class="mySelectBox" v-validate="'required'" >
                    <option :value="selected">--Selected Status-</option>
                
                    <option value="totaldelivered">Total Delivered</option>
                    <option value="ofd">Total OFD</option>
                    <option value="handoverpending">Total NDR</option>
                    <option value="totalrto">Total RTO</option>
                    <option value="failedpickup">Total Failed</option>
                    <option value="inscan">Total Inscan</option>

                  </b-form-select>                                
                </b-form-group>                   
              </b-col>

              <b-col sm="3">
                <b-form-group label="Type:"  :label-cols="4" >
                  <b-form-select v-model="shipmenttype" name="shipmenttype" class="mySelectBox" v-validate="'required'" >
                    <option :value="selected">--Selected type--</option>
                    <option value="SDD">SDD</option>
                    <option value="NDD">NDD</option>  
                     <option value="istrybuy">Istrybuy</option>                 
                  </b-form-select>                                
                </b-form-group>                   
              </b-col>
               <!--  <b-col sm="2">                  
                  <b-button type="submit" variant="primary" size="sm" @click="downloadCSV">Download MIS Report</b-button>                  
                </b-col>  -->               
            </b-row>
            <b-row>
            <b-col md="3" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label="From Date:"  :label-cols="4" >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label="To Date:"  :label-cols="4" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>
              <!--  <b-col sm="3">
                <b-form-group label="Order Flow:"  :label-cols="5" >
                  <b-form-select v-model="orderflow" name="orderflow" class="mySelectBox" v-validate="'required'" >
                    <option :value="selected">--Selected order flow--</option>
                    <option value="both">All</option>
                    <option value="forward">Forward</option>
                    <option value="reverse">Reverse</option>
                  </b-form-select>                                
                </b-form-group>                   
              </b-col> -->
              <b-col sm="3">
                <b-form-group>
                 <b-button type="submit" size="md" variant="primary" @click="showCSV"> Search</b-button>
                 &nbsp;&nbsp;&nbsp;
                  <b-button type="submit" variant="primary" size="md" @click="downloadCSV">Download </b-button>
                </b-form-group>
              </b-col>
            </b-row> 
          </b-form>         
        
          <!--   <b-row class="mb-4">           
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                  <b-input-group>
                    <b-form-select v-model="sortBy" :options="sortOptions">
                      <option slot="first" :value="null">-- none --</option>
                    </b-form-select>
                    <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                      <option :value="false">Asc</option> <option :value="true">Desc</option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>
              </b-col>             
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                  <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                </b-form-group>
              </b-col>            
            </b-row>  -->
            <b-table show-empty stacked="md" :busy="isBusy"   :items="items" :fields="fields"  :current-page="currentPage"  :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  @filtered="onFiltered" :bordered="bordered" > 
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
                 <template slot="packagevalue" slot-scope="row">
                {{ (row.item.packagevalue && row.item.paymenttype!='prepaid') ? row.item.packagevalue:'0' }}
                </template>
            <template slot="show_details" slot-scope="row">
              <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
              </b-button>
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card>
                <b-row>
                  <b-col sm="6">
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order id:</b></b-col>
                      <b-col>{{ row.item.orderid }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Awb No:</b></b-col>
                      <b-col>{{ row.item.awbno }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>City:</b></b-col>
                      <b-col>{{ row.item.branchcity }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Customer Name:</b></b-col>
                      <b-col>{{ row.item.customername }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Vendor Code:</b></b-col>
                      <b-col>{{ row.item.vendorcode }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Origin:</b></b-col>
                      <b-col>{{ row.item.origin }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Vendor LocationID:</b></b-col>
                      <b-col>{{ row.item.vendorpincode }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Destination:</b></b-col>
                      <b-col>{{ row.item.destination }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Location ID:</b></b-col>
                      <b-col>{{ row.item.destinationpincode ? row.item.destinationpincode:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery boy:</b></b-col>
                      <b-col>{{ row.item.deliveryboy ? row.item.deliveryboy:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Mobile Number:</b></b-col>
                      <b-col>{{ row.item.dbmobilenumber ? row.item.dbmobilenumber:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order Status:</b></b-col>
                      <b-col>{{ row.item.orderstatus ? row.item.orderstatus:'-' }}</b-col>
                    </b-row>
                    
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Payment type:</b></b-col>
                      <b-col>{{ row.item.paymenttype ? row.item.paymenttype:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Package Value:</b></b-col>
                      <b-col>{{ (row.item.packagevalue && row.item.paymenttype!='prepaid') ? row.item.packagevalue:'0' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Ccheduled end km:</b></b-col>
                      <b-col>{{ row.item.scheduledendkm ? row.item.scheduledendkm:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Scheduled start km:</b></b-col>
                      <b-col>{{ row.item.scheduledstartkm ? row.item.scheduledstartkm:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Total distance km:</b></b-col>
                      <b-col>{{ row.item.totaldistancekm ? row.item.totaldistancekm:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Is Try Buy:</b></b-col>
                      <b-col>{{ (row.item.istrybuy==1) ? 'Yes':'No' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Client Delivery Date:</b></b-col>
                      <b-col>{{ (row.item.clientedd) ? row.item.clientedd:'-' }}</b-col>
                    </b-row>
                    
                  </b-col>  
                  <b-col sm="6">
                   
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>order Creation :</b></b-col>
                      <b-col>{{ row.item.ordercreationtimestamp ? row.item.ordercreationtimestamp:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Pickup Check Intime:</b></b-col>
                      <b-col>{{ row.item.pickupcheckintime ? row.item.pickupcheckintime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order Confirmed Time:</b></b-col>
                      <b-col>{{ row.item.orderconfirmedtime ? row.item.orderconfirmedtime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Pickup Time:</b></b-col>
                      <b-col>{{ row.item.pickuptime ? row.item.pickuptime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery check intime:</b></b-col>
                      <b-col>{{ row.item.deliverycheckintime ? row.item.deliverycheckintime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery Time:</b></b-col>
                      <b-col>{{ row.item.deliverytime ? row.item.deliverytime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Scheduled Start Time:</b></b-col>
                      <b-col>{{ row.item.scheduledstarttime ? row.item.scheduledstarttime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Scheduled End Time:</b></b-col>
                      <b-col>{{ row.item.scheduledendtime ? row.item.scheduledendtime:'-' }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Total Time Consumed:</b></b-col>
                      <b-col>{{ row.item.totaltimeconsumed ? row.item.totaltimeconsumed:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order Oreation Medium:</b></b-col>
                      <b-col>{{ row.item.orderoreationmedium ? row.item.orderoreationmedium:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivered By:</b></b-col>
                      <b-col>{{ row.item.deliveredby ? row.item.deliveredby:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Cancelled By:</b></b-col>
                      <b-col>{{ row.item.cancelledby ? row.item.cancelledby:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery Notes:</b></b-col>
                      <b-col>{{ row.item.deliverynotes ? row.item.deliverynotes:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>NDR Reason:</b></b-col>
                      <b-col>{{ row.item.ndrreason ? row.item.ndrreason:'-' }}</b-col>
                    </b-row>
                   <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Ship lat long:</b></b-col>
                      <b-col>{{ row.item.shiplonglat ? row.item.shiplonglat:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Pick lat long:</b></b-col>
                      <b-col>{{ row.item.pickloglat ? row.item.pickloglat:'-' }}</b-col>
                    </b-row>

                  
                  </b-col> 
                  <b-col sm="12">
                  <div slot="footer" class="text-right">
                   <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
                  </div> 
                 </b-col> 
                </b-row> 

              </b-card>
            </template>

          </b-table>
          <b-col md="6" class="my-1" v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>     
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
export default {
  data: function() {
    return {
      data: [], 
      items:[],    
      selected:'',
      isBusy: false,   
      orderflow:'both',
      shipmenttype:'',
      shipmentstatus:'',
      hubid:'',
      deliveryagentid:'',
      agentmaster: [],
      showdata: [],
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
      hubdata:[],
      fields: [
          { key: 'orderid', label: 'Orderid', sortable: true, sortDirection: 'desc' },
          { key: 'awbno', label: 'AWBno', sortable: true},
          { key: 'customername', label: 'Customername', sortable: true},
          { key: 'vendoraddress', label: 'VendorAddress', sortable: true},          
          { key: 'destination', label: 'Destination', sortable: true },  
          { key: 'orderstatus', label: 'OrderStatus', sortable: true },
          { key: 'paymenttype', label: 'PaymentType', sortable: true },
          { key: 'packagevalue', label: 'PackageValue' , sortable: true},
          { key: 'show_details', label: 'action' }
        ],
        bordered: true,
        totalRows: 10,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null
    };
  },
  computed: {
    sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
  },
  created: function() {
   
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.hubid=userInfo.pickuplocationmasterid.toString();
    this.displayHubdata();
    this.displaydeliveryagent();
    this.showCSV();
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    validateForm(scope) {},
    getDownloadCsvObject: function(result) {

      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "MISReport_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";


      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    downloadCSV: function() {
     var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
      var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      var orderflow=(this.orderflow!=null)? this.orderflow:"";
      var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
      var shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
      var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
      var csvObj = {
        fromdate: `${fromdate}`,
        todate:`${formatdateto}`,
        serviceid: `${this.hubid}`,
        orderflow:orderflow,
        shipmentstatus:shipmentstatus,
        shipmenttype:shipmenttype,
        deliveryagentid:deliveryagentid,
        shippingid:''      
      };
      if(formatdateto< fromdate){
       alert('To date need to be grater than From date');          
      }
      var r = Math.random().toString(36).substring(3);
      this.$http
        .post(`${CONSTANTS.API_URL}/P2PReports/GetMisReport?c=`+r, csvObj)
        .then(result => {
          if (result.data.returnmsg == "successful") {
            this.getDownloadCsvObject(result.data.returnvalue);          
           alert('MIS Report Downloaded Successfully');
            //document.getElementById("loader").style.display = 'none';
          } else {
             alert(result.body.returnmsg);
         
      
          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });
    },
    showCSV: function() {
       this.isBusy = true;
      /*console.log*/('test '+this.orderflow);
      //  document.getElementById("loader").style.display = 'block'
      var center = this.hubid;
      if(center == undefined){
        alert('Please select center');       
        
      }else{
        var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
        var orderflow=(this.orderflow!=null && this.orderflow!='')? this.orderflow:"both";
        var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
        var shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
        var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";

       
        var csvObj = {
          fromdate: `${fromdate}`,
          todate:`${formatdateto}`,
          serviceid: `${this.hubid}`,
          orderflow:orderflow,
          shipmentstatus:shipmentstatus,
          shipmenttype:shipmenttype,
          deliveryagentid:deliveryagentid,
          shippingid:''
        };
        if(formatdateto< fromdate){
           alert('To date need to be grater than From date');
          
        }

        this.$http.post(`${CONSTANTS.API_URL}/P2PReports/GetMisReport`, csvObj)
          .then(result => {
             this.isBusy = !this.isBusy;
          //  document.getElementById("loader").style.display = 'none'
            if (result.body.returnmsg && result.body.returnmsg === 'NoRecordsFound') {
              this.showdata = []
              this.items  = result.body.returnvalue;
              this.totalRows = 0;

            
            } else if (result.body.length === 0) {
              this.showdata = []
              this.items  = [];
              this.totalRows = 0;
            
            } else if (result.body.returnmsg === 'error') {
             this.showdata = []
              this.items  = [];
              this.totalRows = 0;
               alert(result.body.returnvalue);
             
            } else if (result.body.returnmsg === 'InputException') {
              this.showdata = []
              this.items  = [];
              this.totalRows = 0;
               alert(result.body.returnvalue);
             
            }else if (result.body.returnmsg === 'DBException') {
              this.showdata = []
              this.items  = [];
              this.totalRows = 0;
               alert(result.body.returnvalue);
             
            } else {
                this.showdata = result.body.returnvalue;
                this.items  = result.body.returnvalue;
                this.totalRows = result.body.returnvalue.length;
            }
          })
          .catch(ex => {
            console.log("error-----", ex);
          });
      }
    },
    convertArrayOfObjectsToCSV: function(args) {
       var result, ctr, keys, columnDelimiter, lineDelimiter, data;
       data = args.data || null;
       if (data == null || !data.length) {
         return null;
       }    

       columnDelimiter = args.columnDelimiter || ",";
       lineDelimiter = args.lineDelimiter || "\n";

       data.forEach(function(item) {
        delete item.attempt;
        delete item.clientname
        delete item.clientbranchname;
        delete item.branchcity;
        delete item.scheduledstartkm;
        delete item.scheduledendkm;
        delete item.totaldistancekm;
        delete item.scheduledstarttime;
        delete item.scheduledendtime;
        delete item.totaltimeconsumed;
        delete item.ordercreationmedium;
        delete item.pickupcheckintime1;
        delete item.deliverycheckintime1;
        delete item.allowcheckedin;
        delete item.orderconfirmedtime;
        delete item.pickupcheckintime;
        delete item.pickuptime;
        delete item.deliverytime;
        delete item.type;
        delete item.shiplonglat;
        delete item.pickloglat;
        delete item.deliverystatus;
        delete item.logdata;
       
    });
   
       //.slice(0,-4)
       keys = Object.keys(data[0]);
//        console.log('*********************');
// console.log(data);
//        console.log('*********************');
       // console.log('=========================');
// console.log(keys);
       // console.log('=========================');
// return false;
       result = "";
       result += keys.join(columnDelimiter);
       result += lineDelimiter;
       data.forEach(function(item) {
       var logdata = item['logdata'];
       var attempt = item['attempt'];
       var allowcheckedin = item['allowcheckedin']

        item['pickupcheckintime'] = null;
        item['pickuptime'] = null;

        item['orderconfirmedtime'] = null;
        item['deliverytime'] = null;
        item['ordercreationtimestamp'] = "'"+item['ordercreationtimestamp'];
        item['scheduledstarttime'] = "'"+item['scheduledstarttime'];
        item['scheduledendtime'] = "'"+item['scheduledendtime'];

         // if(logdata!==null){

         //   logdata.forEach(function(itm){
         //     let mydate = new Date(itm.createddate);
         //     let month=mydate.getMonth()+1;
         //     let createddate="'"+mydate.getFullYear()+"-"+month+"-"+mydate.getDate()+" "+mydate.getHours()+":"+mydate.getMinutes();
         //     switch(itm.process) {
         //       case 'BookingDone':
         //           if(attempt !== null)
         //           {
         //               if(attempt == itm.attempt)
         //               {
         //                 item['orderconfirmedtime'] = createddate.toString();
         //                 break;
         //               }
         //            }else {
         //               item['orderconfirmedtime'] = createddate.toString();
         //              break;
         //            }
         //       case 'OFD':
         //            if(attempt !== null)
         //           {
         //               if(attempt == itm.attempt)
         //               {
         //                 if(allowcheckedin == 'true'){
         //                   item['pickupcheckintime'] = item['pickupcheckintime1'];
         //                   item['pickuptime'] = createddate.toString();
         //                   break;
         //                 }else {

         //                   item['pickupcheckintime'] = createddate.toString();
         //                   item['pickuptime'] = createddate.toString();
         //                   break;
         //                 }
         //               }
         //          }else {
         //            if(allowcheckedin == 'true'){
         //              item['pickupcheckintime'] = item['pickupcheckintime1'];
         //              item['pickuptime'] = createddate.toString();
         //              break;
         //            }else {
         //              item['pickupcheckintime'] = createddate.toString();
         //              item['pickuptime'] = createddate.toString();
         //              break;
         //            }
         //          }
         //       case 'DLV':
         //         if(attempt !== null)
         //         {
         //             if(attempt == itm.attempt)
         //             {
         //                if(allowcheckedin == 'true'){
         //                   item['deliverycheckintime'] = item['deliverycheckintime1'];
         //                   item['deliverytime'] = createddate.toString();
         //                   break;
         //                }else {
         //                  item['deliverycheckintime'] = createddate.toString();
         //                  item['deliverytime'] = createddate.toString();
         //                  break;
         //                }
         //             }
         //        }else {
         //            if(allowcheckedin == 'true'){
         //               item['deliverycheckintime'] = item['deliverycheckintime1'];
         //               item['deliverytime'] = createddate.toString();
         //               break;
         //            }else {
         //              item['deliverycheckintime'] = createddate.toString();
         //              item['deliverytime'] = createddate.toString();
         //              break;
         //            }
         //        }

         //        case 'NDR':
         //          if(attempt !== null)
         //          {
         //              if(attempt == itm.attempt)
         //              {
         //                item['deliverycheckintime'] = null;
         //                item['deliverytime'] = null;
         //                break;
         //              }
         //         }else {
         //                item['deliverycheckintime'] = null;
         //                item['deliverytime'] = null;
         //             break;
         //         }
         //     }
         //   });
         // } else {
         //   item['deliverytime'] = '';
         //   item['orderconfirmedtime'] = '';
         //   item['pickupcheckintime'] = '';
         //   item['pickuptime'] = '';
         // }
         ctr = 0;      
              //       console.log('-----datta---------------');
         keys.forEach(function(key) {
          // console.log('--------------------');
          // console.log(key);
          //  console.log('--------------------');
          //  console.log(item[key]);
          //           console.log('-----datta---------------');
//&& key!='logdata'
           if (ctr > 0) result += columnDelimiter;
           if (item[key] != null ) {
            if(key=='istrybuy'){
              var istrybuy=(item[key]==1)?'Yes':'No';
               result += '"' + istrybuy + '"';
            }else if(key=='packagevalue'){
              var packagevalue=(item['paymenttype']!='prepaid')?item[key]:'0';
               result += '"' + packagevalue + '"';
            }else if(key=='deliverycheckintime' || key=='ordercreationtimestamp'){
              var d = new Date(item[key]),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();
              if (month.length < 2) month = "0" + month;
              if (day.length < 2) day = "0" + day;
               var deliverycheckintime= [year, month, day].join("-");
               result += '"' + deliverycheckintime + '"';
            }else if(key=='origin'){
                var str2=item[key];
                str2=str2.replace('#','');
                result += '"' +str2 + '"';
             }else{
             result += '"' + item[key] + '"';     
            } 
           }           
           
           ctr++;
         });
         result += lineDelimiter;

       });
     //  document.getElementById("loader").style.display = 'none';

       return result;
     },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    displayHubdata: function() {
      const deliveryagentobj = {}
      this.$http.post(`${CONSTANTS.API_URL}/P2PReports/GetAllHubListMaster`)
        .then(result => {
          this.hubdata = result.body.returnvalue;
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
    },

    displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
      this.$http.post(`${CONSTANTS.API_URL}/DeliveryAgentMaster.svc/DeliveryAgentMasterGetAll`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    }

  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}
</style>
